import { render, staticRenderFns } from "./TdPreview.vue?vue&type=template&id=16f67d96&scoped=true&"
import script from "./TdPreview.vue?vue&type=script&lang=js&"
export * from "./TdPreview.vue?vue&type=script&lang=js&"
import style0 from "./TdPreview.vue?vue&type=style&index=0&id=16f67d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f67d96",
  null
  
)

export default component.exports